<template>
	<b-modal
		ref="configure-reason-modal"
		centered
		:title="getTitle"
		v-model="isActive"
		no-close-on-backdrop
		@hidden="handleHidden(false)"
		size="xmd"
		hide-footer
	>
		<b-overlay :show="isLoading">
			<div class="d-flex align-items-center justify-content-end">
				<b-button variant="outline-primary" style="white-space: nowrap" @click="openModifyReason('create')">
					Agregar motivo
				</b-button>
			</div>
			<b-table
				class="mt-2"
				ref="configure-reason-table"
				id="configure-reason-table"
				sticky-header="60vh"
				show-empty
				:busy.sync="isBusy"
				responsive="sm"
				:items="reasons"
				:fields="fields"
			>
				<template #table-busy>
					<div class="text-center text-primary my-2">
						<b-spinner class="align-middle mr-1" />
						<strong>Loading ...</strong>
					</div>
				</template>
				<template #cell(id)="row">
					{{ row.index + 1 }}
				</template>
				<template #cell(reason)="{ item }">
					{{ item.reason }}
				</template>
				<template #cell(specimens)="row">
					<b-button variant="flat-info" @click="openSpecimenDeadDetails(row.item)">
						{{ row.item.used_count }}
					</b-button>
				</template>
				<template #cell(details)="row">
					<div class="d-flex justify-content-center align-items-center">
						<b-button variant="flat-warning" @click="openModifyReason('edit', row.item)">
							<feather-icon size="20" icon="EditIcon" />
						</b-button>
						<b-button variant="flat-danger" @click="deleteReason(row.item)">
							<feather-icon size="20" icon="TrashIcon" />
						</b-button>
						<b-button variant="flat-success" @click="openModifyReason('create', row.item)">
							<feather-icon class="text-success" icon="PlusIcon" size="21" />
						</b-button>
						<b-badge
							v-if="row.item.subReasons.length"
							variant="primary"
							style="width: 50px"
							@click="row.toggleDetails"
							class="cursor-pointer"
						>
							<feather-icon
								class="text-white"
								:icon="row.detailsShowing ? 'ChevronUpIcon' : 'ChevronDownIcon'"
								size="21"
							/>
						</b-badge>
					</div>
				</template>
				<template #row-details="row">
					<b-card class="m-0 p-0 custom-card">
						<b-table-simple class="mt-1" sticky-header="60vh">
							<b-tbody class="text-center">
								<b-tr v-for="(reason, index) in row.item.subReasons" :key="index">
									<b-td class="text-center">
										<span>{{ `${row.index + 1}.${index + 1}` }}</span>
									</b-td>
									<b-td class="text-center">
										<span>{{ reason.reason }}</span>
									</b-td>
									<b-td class="text-center">
										<b-button variant="flat-info" @click="openSpecimenDeadDetails(reason)">
											{{ reason.used_count }}
										</b-button>
									</b-td>
									<b-td class="text-center">
										<div class="d-flex justify-content-center">
											<b-button variant="flat-warning" @click="openModifyReason('edit', reason)">
												<feather-icon size="20" icon="EditIcon" />
											</b-button>
											<b-button variant="flat-danger" @click="deleteReason(reason)">
												<feather-icon size="20" icon="TrashIcon" />
											</b-button>
										</div>
									</b-td>
								</b-tr>
								<b-tr v-if="reasons.length === 0">
									<b-td colspan="3" class="text-center" style="height: 80px">
										No hay registros para mostrar
									</b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</b-card>
				</template>
			</b-table>
		</b-overlay>

		<b-modal v-if="showAdd" v-model="showAdd" :title="title" centered size="md" @hidden="closeModify">
			<b-form-input v-model="name" />
			<template #modal-footer>
				<b-button v-if="actionModal === 'create'" variant="success" @click="save">Guardar</b-button>
				<b-button v-else variant="success" @click="edit(reason)">Guardar</b-button>
			</template>
		</b-modal>
		<BrainSpecimenDeadDetails
			v-if="showSpecimenDeadDetails"
			:reason="selectedReason"
			@close="showSpecimenDeadDetails = false"
		/>
	</b-modal>
</template>

<script>
import modalMixin from "@/mixins/modal"
import specimenStatusService from "@/services/specimenStatus.service"
import BrainSpecimenDeadDetails from "@/views/brain/specimens/components/BrainSpecimenDeadDetails.vue"
export default {
	components: { BrainSpecimenDeadDetails },
	props: {
		show: Boolean,
		info: Object,
		indexTab: Number,
		statusId: Number,
	},
	mixins: [modalMixin],
	data: () => ({
		isActive: false,
		isLoading: false,
		title: null,
		name: null,
		galpon: 1,
		reasons: [],
		parentId: null,
		showAdd: false,
		actionModal: "",
		reasonInfo: {},
		isBusy: false,
		showSpecimenDeadDetails: false,
		selectedReason: null,
		fields: [
			{
				key: "id",
				label: "#",
				visible: true,
				thClass: "text-center",
				tdClass: "text-center",
			},
			{
				key: "reason",
				label: "Motivo",
				visible: true,
				thClass: "text-center",
				tdClass: "text-center",
			},
			{
				key: "specimens",
				label: "Ejemplares",
				visible: true,
				thClass: "text-center",
				tdClass: "text-center",
			},
			{
				key: "details",
				label: "Ver detalles",
				visible: true,
				thClass: "text-center",
				tdClass: "text-center",
			},
		],
	}),
	computed: {
		getTitle() {
			return `Motivos del estado ${this.info.description.toUpperCase()}`
		},
	},
	async mounted() {
		this.toggleModal("configure-reason-modal")
	},
	methods: {
		openSpecimenDeadDetails(reason) {
			this.selectedReason = {
				id: reason.id,
				name: reason.reason,
			}
			this.showSpecimenDeadDetails = true
		},
		handleHidden(is_refresh) {
			this.isActive = false
			this.isLoading = false
			this.name = null
			this.galpon = 1
			this.$emit("closing", { is_refresh, info: this.info })
		},
		closeModify() {
			this.showAdd = false
			this.name = null
		},
		openModifyReason(action, reason) {
			if (action === "create") {
				this.name = null
				if (reason) {
					this.parentId = reason.id
					this.title = `Agregar nuevo submotivo a ${reason.reason}`
				} else {
					this.parentId = null
					this.title = "Agregar nuevo motivo"
				}
			} else {
				this.name = reason.reason
				this.title = "Editar motivo"
			}
			this.actionModal = action
			this.showAdd = true
			this.reasonInfo = reason
		},
		async getReasons() {
			this.isPreloading()
			try {
				const { data } = await specimenStatusService.getReasons({ status_id: this.statusId })
				const dataGrouped = data.filter((item) => !item.parent_id)
				dataGrouped.forEach((item) => {
					item.subReasons = data.filter((subItem) => subItem.parent_id === item.id)
				})
				this.reasons = dataGrouped
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async editReason(reason) {},
		async deleteReason(reason) {
			const { isConfirmed } = await this.showConfirmSwal({ text: `Se eliminará el motivo ${reason.reason}.` })
			if (!isConfirmed) return
			this.isPreloading()

			try {
				const res = await specimenStatusService.deleteReason({ id: reason.id })
				this.getReasons()
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async save() {
			const { isConfirmed } = await this.showConfirmSwal()
			if (!isConfirmed) return

			this.isPreloading()
			try {
				await specimenStatusService.createReason({
					status_id: this.statusId,
					reason: this.name,
					parent_id: this.parentId,
				})
				this.getReasons()
				this.$emit("refresh")
				this.closeModify()
			} catch (error) {
				const message = error.response?.data?.data?.error
				console.log(error)
				console.log(message)

				this.showToast("warning", "top-right", "Advertencia", "AlertTriangleIcon", `${message}`)
				return
			} finally {
				this.isPreloading(false)
			}
		},
		async edit() {
			const { isConfirmed } = await this.showConfirmSwal()
			if (!isConfirmed) return
			this.isPreloading()
			try {
				const res = await specimenStatusService.editReason({
					id: this.reasonInfo.id,
					reason: this.name,
					status_id: this.statusId,
				})
				this.getReasons()
				this.closeModify()
			} catch (error) {
				const message = error.response?.data?.data?.error
				console.log(error)
				console.log(message)

				this.showToast("warning", "top-right", "Advertencia", "AlertTriangleIcon", `${message}`)
			} finally {
				this.isPreloading(false)
			}
		},
	},
	async created() {
		await this.getReasons()
	},
}
</script>
<style lang="scss" scoped>
.custom-card {
	border: 3px solid var(--primary);
	border-radius: 10px;
	padding: 1rem;
}
</style>
